export const isClassroomMagazine = (rosterSupport: string) => rosterSupport.toLowerCase() === 'cm';

export default isClassroomMagazine;
